import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [ripples, setRipples] = useState<{ id: number; delay: number }[]>([]);
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const rippleList = [
      { id: 1, delay: 0 },
      { id: 2, delay: 2.0 },
      { id: 3, delay: 4.0 },
      { id: 4, delay: 6.0 },
    ];
    setRipples(rippleList);

    const timer = setTimeout(() => {
      setTextVisible(true);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  const scrollToNext = () => {
    const element = document.getElementById('philosophy');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f4d61e2b56ecafac352304f35eda7bb8.jpg"
          alt="Japanese Archipelago"
          className="w-full h-full object-cover object-top"
          style={{ animation: 'heroImagePulse 8s ease-in-out infinite' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Ripple Effects */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {ripples.map((ripple) => (
          <div
            key={ripple.id}
            className="absolute rounded-full border border-white/20"
            style={{
              width: '10px',
              height: '10px',
              animation: `rippleExpand 8s ease-out infinite`,
              animationDelay: `${ripple.delay}s`,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center px-6 md:px-8 w-full">
        <div className="text-center w-full max-w-4xl mx-auto">
          {/* Main Copy — Mobile: 句読点で改行 / PC: 1行 */}
          <h1
            className="font-sans font-bold text-white mb-6 tracking-wide leading-tight"
            style={{
              fontSize: 'clamp(1.6rem, 5vw, 4.5rem)',
              opacity: textVisible ? 1 : 0,
              transform: textVisible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.97)',
              transition: 'opacity 2s ease-out, transform 2s ease-out',
            }}
          >
            {/* モバイル表示 */}
            <span className="block md:hidden">
              The rhythm of<br />
              the ocean currents,<br />
              the melody of<br />
              the archipelago.
            </span>
            {/* PC表示 */}
            <span className="hidden md:block">
              The rhythm of the ocean currents,<br />
              the melody of the archipelago.
            </span>
          </h1>

          {/* Sub Copy */}
          <p
            className="font-sans text-white/95 font-light tracking-wider"
            style={{
              fontSize: 'clamp(0.85rem, 2.2vw, 1.5rem)',
              opacity: textVisible ? 1 : 0,
              transform: textVisible ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 2s ease-out, transform 2s ease-out',
              transitionDelay: '0.6s',
            }}
          >
            {/* モバイル表示 */}
            <span className="block md:hidden">
              The Structure of Japanese Music<br />
              Born from Insular Sensibility.
            </span>
            {/* PC表示 */}
            <span className="hidden md:block">
              The Structure of Japanese Music Born from Insular Sensibility.
            </span>
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-colors cursor-pointer animate-bounce"
        aria-label="Scroll to next section"
        style={{
          opacity: textVisible ? 1 : 0,
          transition: 'opacity 1.5s ease-out',
          transitionDelay: '2s',
        }}
      >
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </button>

      <style>{`
        @keyframes rippleExpand {
          0% { width: 10px; height: 10px; opacity: 0.5; border-color: rgba(255,255,255,0.35); }
          100% { width: 120vw; height: 120vw; opacity: 0; border-color: rgba(255,255,255,0); }
        }
        @keyframes heroImagePulse {
          0%, 100% { transform: scale(1.0); }
          50% { transform: scale(1.04); }
        }
      `}</style>
    </section>
  );
}
